const IST_TIME_ZONE = "Asia/Kolkata";

export const normalizeIstTimestamp = (timestamp: string): string => {
  const trimmed = timestamp.trim();
  if (!trimmed) return trimmed;
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed.replace(" ", "T")}+05:30`;
};

export const parseBackendTimestamp = (timestamp: string): Date => {
  return new Date(normalizeIstTimestamp(timestamp));
};

export const formatIstDateTime = (
  timestamp: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  if (!timestamp) return "";

  const date = parseBackendTimestamp(timestamp);
  if (Number.isNaN(date.getTime())) return timestamp;

  return date.toLocaleString("en-IN", {
    timeZone: IST_TIME_ZONE,
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...options,
  });
};

export const formatIstDate = (
  timestamp: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  if (!timestamp) return "";

  const date = parseBackendTimestamp(timestamp);
  if (Number.isNaN(date.getTime())) return timestamp;

  return date.toLocaleDateString("en-IN", {
    timeZone: IST_TIME_ZONE,
    ...options,
  });
};

export const normalizeUtcTimestamp = (timestamp: string): string => {
  const trimmed = timestamp.trim();
  if (!trimmed) return trimmed;
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed.replace(" ", "T")}Z`;
};

export const formatUtcDateTime = (
  timestamp: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  if (!timestamp) return "";

  const date = new Date(normalizeUtcTimestamp(timestamp));
  if (Number.isNaN(date.getTime())) return timestamp;

  return date.toLocaleString("en-IN", {
    timeZone: IST_TIME_ZONE,
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...options,
  });
};
